var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.565784
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 1C81.6988 1 105 24.3012 105 53C105 81.6988 81.6988 105 53 105C24.3012 105 1 81.6988 1 53C1 24.3012 24.3012 1 53 1Z",
    fill: "#E3EDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 1C81.6988 1 105 24.3012 105 53C105 81.6988 81.6988 105 53 105C24.3012 105 1 81.6988 1 53C1 24.3012 24.3012 1 53 1Z",
    stroke: "white",
    strokeWidth: 0.788136
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0015 13.2842C75.6884 13.2842 94.1102 31.7059 94.1102 54.3929C94.1102 77.0799 75.6884 95.5017 53.0015 95.5017C30.3145 95.5017 11.8927 77.0799 11.8927 54.3929C11.8927 31.7059 30.3145 13.2842 53.0015 13.2842Z",
    fill: "#7BB20E",
    stroke: "white",
    strokeWidth: 4.89474
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8887 54.9169L46.5618 67.3439L72.1541 40.8903",
    stroke: "white",
    strokeWidth: 6.60157,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.de5e4052f95121e9d867cd6bbee13975.svg";
export { ForwardRef as ReactComponent };